<template>
    <div class="tool-response-message">
        <div class="tool-header">
            <span class="tool-icon">📋</span>
            <span class="tool-title">工具执行结果</span>
        </div>
        <div class="tool-content">
            <div v-for="(response, index) in responses" :key="index" class="tool-item">
                <div class="tool-item-header">
                    <span class="tool-name">{{ response.name || 'Unknown Tool' }}</span>
                    <span v-if="response.id" class="tool-id">{{ response.id }}</span>
                </div>
                <div class="tool-result-wrapper">
                    <div class="result-label">返回结果:</div>
                    <div v-if="isJson[index]" class="tool-result json">
                        <pre>{{ formattedResult[index] }}</pre>
                    </div>
                    <div v-else class="tool-result">
                        <pre>{{ response.responseData }}</pre>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    responses: {
        type: Array,
        default: () => []
    }
})

const isJson = computed(() => {
    if (!props.responses || props.responses.length === 0) return []
    return props.responses.map(response => {
        if (!response.responseData) return false
        try {
            JSON.parse(response.responseData)
            return true
        } catch {
            return false
        }
    })
})

const formattedResult = computed(() => {
    if (!props.responses || props.responses.length === 0) return []
    return props.responses.map(response => {
        if (!response.responseData) return ''
        try {
            return JSON.stringify(JSON.parse(response.responseData), null, 2)
        } catch {
            return response.responseData
        }
    })
})
</script>

<style lang="scss" scoped>
.tool-response-message {
    background: linear-gradient(135deg, #F5F5F5, #FAFAFA);
    border: 1px solid #E0E0E0;
    border-radius: 12px;
    padding: 12px;
    margin: 4px 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.tool-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    color: #666;
}

.tool-icon {
    font-size: 16px;
}

.tool-title {
    font-weight: 600;
    font-size: 13px;
}

.tool-content {
    background: white;
    border-radius: 8px;
    overflow: hidden;
}

.tool-item {
    padding: 10px;
    border-bottom: 1px solid #E8E8E8;

    &:last-child {
        border-bottom: none;
    }
}

.tool-item-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
}

.tool-name {
    font-weight: 600;
    color: #333;
    font-size: 13px;
    font-family: 'Monaco', 'Menlo', monospace;
}

.tool-id {
    font-size: 10px;
    color: #999;
    font-family: 'Monaco', 'Menlo', monospace;
    background: #f0f0f0;
    padding: 2px 6px;
    border-radius: 3px;
}

.tool-result-wrapper {
    .result-label {
        font-size: 11px;
        color: #666;
        margin-bottom: 4px;
        font-weight: 500;
    }
}

.tool-result {
    background: #fafafa;
    border-radius: 6px;
    padding: 8px;
    margin-top: 4px;
    max-height: 200px;
    overflow-y: auto;

    &.json {
        background: #F0F9FF;
        border: 1px solid #E8F0FE;
    }

    pre {
        margin: 0;
        font-size: 12px;
        color: #333;
        font-family: 'Monaco', 'Menlo', monospace;
        white-space: pre-wrap;
        word-break: break-all;
    }
}
</style>
